import React from 'react';

interface CallMetricsCardProps {
  icon: React.ReactNode;
  title: string;
  value: string;
  change: string;
  isPositive: boolean;
}

export default function CallMetricsCard({
  icon,
  title,
  value,
  change,
  isPositive,
}: CallMetricsCardProps) {
  return (
    <div className="bg-white rounded-lg shadow p-6">
      <div className="flex items-center justify-between">
        <div className="p-2 bg-gray-50 rounded-lg">{icon}</div>
        <span
          className={`text-sm font-medium ${
            isPositive ? 'text-green-600' : 'text-red-600'
          }`}
        >
          {change}
        </span>
      </div>
      <h3 className="mt-4 text-lg font-medium text-gray-900">{value}</h3>
      <p className="text-sm text-gray-500">{title}</p>
    </div>
  );
}